import { firebase, auth } from '@/plugins/firebase';
import * as userServices from '@/services/userServices';
import * as DateTime from '@/utils/date';

// Firebase Authenticationの操作

export async function updateUserProfile(payload) {
  await getFirebaseUser()
    .updateProfile({
      displayName: payload.nickname,
      photoURL: payload.photoURL
    })
    .catch(err => console.error('Update User Profile Error', err.message));
  return;
}

export function getFirebaseUser() {
  return auth.currentUser;
}

export function getUID() {
  return getFirebaseUser().uid;
}

// ユーザー登録するときに必要な初期値をソーシャルアカウントの情報から取得する。
// ユーザーの情報が正しく取得できなかった場合はnullを返す。
export function getInitialUserValueFromSocialAccount() {
  const user = getFirebaseUser();
  if (!user) {
    return null;
  }
  return {
    email: user.email,
    nickname: user.displayName,
    photoURL: user.photoURL
  };
}

// メールアドレス重複チェック
export async function checkEmailDuplicated(email) {
  const providers = await firebase.auth().fetchSignInMethodsForEmail(email);
  let result = providers.findIndex(p => p === firebase.auth.EmailAuthProvider.EMAIL_PASSWORD_SIGN_IN_METHOD) !== -1; // eslint-disable-line no-unused-vars
}

// ユーザを作成する
export async function createUser(email, password) {
  return await auth.createUserWithEmailAndPassword(email, password);
}

// 確認メールを送信する
export async function sendEmailVerification() {
  // ルートパスにリダイレクト
  const url = `${location.protocol}//${location.hostname}${
    location.port ? `:${location.port}` : ''
  }/email-confirmed`;
  auth.languageCode = 'ja';
  const fbUser = getFirebaseUser();
  try {
    await fbUser.sendEmailVerification({
      url: url
    });
  } catch (err) {
    if (err.code === 'auth/too-many-requests') {
      alert(
        '確認メールを再送できませんでした。数分後にもう一度お試しください。',
        `${fbUser.email}宛に確認メールを送信できませんでした: ${err}`
      );
      return;
    }
    alert(
      '[Error] Can not send mail',
      `${fbUser.email}宛に確認メールを送信できませんでした: ${err}`
    );
    console.error(err);
    return;
  }
}

export async function resetPassoword(password, newPassword) {
  const user = auth.currentUser;
  const credential = firebase.auth.EmailAuthProvider.credential(
    user.email,
    password
  );
  await user.reauthenticateWithCredential(credential);
  await user.updatePassword(newPassword);
}

export async function setSigninDateTime(userId) {
  let singinAt = (await DateTime.serverDate()).toJSDate()
  sessionStorage[createStorageKey()] = singinAt.getTime();
  await userServices.updateUserDoc(userId, {
    singinAt: singinAt
  });
}

export function removeSigninDateTime() {
  sessionStorage.removeItem(createStorageKey());
}

export async function checkSigninDateTime() {
  const user = auth.currentUser;
  const sessionValue = sessionStorage.getItem(createStorageKey());
  if (!user || !sessionValue) {
    return false;
  }
  const userDoc = await userServices.getUserDoc(user.uid);
  if (!userDoc) {
    return false;
  }
  const sessionSinginAt = new Date(Number(sessionValue));
  const dbSinginAt = userDoc.singinAt ? DateTime.fromUnixToJSDate(userDoc.singinAt.seconds) : null;

  return !dbSinginAt || dbSinginAt <= sessionSinginAt;
}

function createStorageKey() {
  return `firebase:authUser:extend:${process.env.VUE_APP_FIREBASE_API_KEY}`;
}
